module.exports = __webpack_public_path__ + "img/1670832602135-IMG-20221212-WA0001.jpg.f71e5e7b.webp";